import { Location } from 'history';
import * as qs from 'qs';
import * as React from 'react';
import * as url from 'url';

export interface IUrl extends Partial<Location> {
  protocol?: string;
  host?: string;
  hostname?: string;
  hash?: string;
  referer?: string;
}

export const URLContext = React.createContext<IUrl>({});

export function buildUrlContextObject(urlString: string, referer: string): IUrl {
  if (!urlString) return {};

  const {
    protocol,
    host,
    hostname,
    pathname,
    search: queryString,
    hash,
  } = url.parse(urlString);

  const query = qs.parse(queryString, { ignoreQueryPrefix: true });

  const search = qs.stringify(query, {
    encodeValuesOnly: true,
    arrayFormat: 'brackets',
    addQueryPrefix: true,
  });

  return {
    referer,
    protocol,
    host,
    hostname,
    pathname,
    search,
    query,
    hash,
  };
}

export function useURL(): Partial<IUrl> {
  return React.useContext(URLContext);
}

export function withUrlContext(Wrapped) {
  return (props) => (
    <URLContext.Consumer>
      {(urlContextObject) => (<Wrapped url={urlContextObject} {...props} />)}
    </URLContext.Consumer>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/url_context.tsx